if (!customElements.get('variant-cross-sell')) {
    customElements.define('variant-cross-sell',
  
      class VariantCrossSell extends HTMLElement {
        constructor() {
          super();
          this.swiper = null;
          this.onAtcClick = this.onAtcClick.bind(this);
        }
  
        connectedCallback() {
          this.initSwiper();
          this.addEventListener('click', this.onAtcClick.bind(this));
        }
  
        disconnectedCallback() {
          this.swiper?.destroy(true, true);
          this.swiper = null;
        }
  
        initSwiper() {
          if (typeof Swiper === 'undefined') return;
  
          const desktopSlides = parseInt(this.dataset.desktopSlides) || 3;
          const tabletSlides = Math.max(1, desktopSlides / 1.5);
          const desktopGap = parseInt(this.dataset.desktopGap) || 16;
          const mobileGap = parseInt(this.dataset.mobileGap) || 12;
  
          this.swiper = new Swiper(this.querySelector('.vcs-swiper'), {
            slidesPerView: 1,
            spaceBetween: mobileGap,
            navigation: {
              prevEl: this.querySelector('.vcs-prev'),
              nextEl: this.querySelector('.vcs-next'),
            },
            breakpoints: {
              750: {
                slidesPerView: tabletSlides,
                spaceBetween: desktopGap,
              },
              990: {
                slidesPerView: desktopSlides,
                spaceBetween: desktopGap,
              },
            },
          });
        }
  
        onAtcClick(event) {
          const btn = event.target.closest('.vcs-atc-btn');
          if (!btn) return;
          if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

          const variantId = parseInt(btn.dataset.variantId);
          if (!variantId) return;
  
          this.addToCart(btn, variantId);
        }
  
        async addToCart(btn, variantId) {
          if (btn.getAttribute('aria-disabled') === 'true') return;
  
          btn.setAttribute('aria-disabled', 'true');
          const spinner = btn.querySelector('.vcs-card__spinner');
          const label = btn.querySelector('.vcs-card__atc-label');
          const atcPrice = btn.querySelector('.vcs-card__atc-price');
          const plusIcon = btn.querySelector('svg');
  
          if (spinner) spinner.classList.remove('hidden');
          if (label) label.style.visibility = 'hidden';
          if (atcPrice) atcPrice.style.visibility = 'hidden';
          if (plusIcon) plusIcon.style.visibility = 'hidden';
  
          try {
            await this.waitForCartAdd(() =>
              window.liquidAjaxCart.add({ items: [{ id: variantId, quantity: 1 }] })
            );
  
            document.body.classList.add('js-show-ajax-cart');
            document.dispatchEvent(new CustomEvent('item-added-to-cart'));
          } catch (error) {
            console.error('Variant cross-sell: add to cart failed', error);
          } finally {
            btn.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');
            if (label) label.style.visibility = '';
            if (atcPrice) atcPrice.style.visibility = '';
            if (plusIcon) plusIcon.style.visibility = '';
          }
        }
  
        waitForCartAdd(addFn) {
          return new Promise((resolve, reject) => {
            const onRequestEnd = (event) => {
              const { requestState } = event.detail || {};
              if (requestState?.requestType !== 'add') return;
  
              document.removeEventListener('liquid-ajax-cart:request-end', onRequestEnd);
  
              if (requestState.responseData?.ok) {
                resolve();
              } else {
                reject(new Error('Add to cart request failed'));
              }
            };
  
            document.addEventListener('liquid-ajax-cart:request-end', onRequestEnd);
            addFn();
          });
        }
      }
    );
  }
  